export const ORDER_STATUS = {
  INIT_MEASURE: "initMeasure",
  PLANNING: "planning",
  FINAL_MEASURE: "finalMeasure",
  MANUFACTURING: "manufacturing",
  INSTALLATION: "installation",
  COMPLETED: "completed",
};

export const ORDER_STATUS_ARABIC = {
  [ORDER_STATUS.INIT_MEASURE]: "الكيال المبدئي",
  [ORDER_STATUS.PLANNING]: "الرسم الهندسي",
  [ORDER_STATUS.FINAL_MEASURE]: "الكيال النهائي",
  [ORDER_STATUS.MANUFACTURING]: "التصنيع",
  [ORDER_STATUS.INSTALLATION]: "التركيب",
  [ORDER_STATUS.COMPLETED]: "تم الإنجاز",
};